import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
  if (!process.env.SENTRY_DSN) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Sentry DSN not configured');
    }
    return;
  }

  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENVIRONMENT || 'development',
    release: process.env.npm_package_version || '1.0.0',

    // Performance Monitoring - only in production to avoid development noise
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,

    // Configure which errors to ignore
    ignoreErrors: [
      // Ignore common browser extension errors
      'Non-Error promise rejection captured',
      'Non-Error exception captured',
      'ChunkLoadError',
      'Loading chunk',
      // Ignore network errors that users can't control
      'Network request failed',
      'NetworkError',
      'TypeError: Failed to fetch',
      // Ignore common third-party script errors
      'Script error',
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
    ],

    // Configure which URLs to ignore
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
    ],

    // Data scrubbing
    beforeSend(event) {
      // Don't send events in development unless explicitly enabled
      if (process.env.NODE_ENV === 'development' && !process.env.SENTRY_DEBUG) {
        return null;
      }

      // Filter out user data from event
      if (event.request) {
        delete event.request.cookies;
        delete event.request.headers;
      }

      return event;
    },

    // Set initial user context
    initialScope: {
      tags: {
        component: 'ticketspot-widget',
      },
      user: {
        // Will be set when user data is available
      },
    },
  });

  // Set up global error handler for unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason);
  });
};

// Helper to set user context
export const setSentryUser = (userData) => {
  Sentry.setUser({
    id: userData.id,
    email: userData.email,
    // Don't include sensitive data
  });
};

// Helper to add custom tags
export const setSentryTags = (tags) => {
  Object.entries(tags).forEach(([key, value]) => {
    Sentry.setTag(key, value);
  });
};

// Helper to add breadcrumb
export const addBreadcrumb = (message, category = 'ui', level = 'info', data = {}) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    data,
    timestamp: Date.now() / 1000,
  });
};
